import {Checkbox, CheckboxProps, FormControlLabel} from "@mui/material";
import {mergeSx} from "src/utils/styles.ts";

export interface AavoCheckboxProps extends CheckboxProps {
    disabled?: boolean;
    required?: boolean;
    label?: string;
}

export const AavoCheckbox = ({
                                 disabled,
                                 required,
                                 label,
                                 sx,
                                 ...other
                             }: AavoCheckboxProps) => {
    if (!label) {
        return <Checkbox {...other} />;
    } else {
        return (
            <FormControlLabel
                control={
                    <Checkbox {...other} />
                }
                required={required}
                disabled={disabled}
                label={label}
                sx={mergeSx({
                    margin: 0,
                }, sx)}
            />
        );
    }
};
